import { B2BDealType, B2CDealType, CostDealType } from "@/app/constants";

import { PricingStrategy, PriceResult } from "../base/pricing.strategy";
import { ReactiveComponent } from "../../entities/base-component";
import { Partition } from "../../entities/partition";

export class PartitionPricingStrategy extends PricingStrategy {
    public getPrices(component: ReactiveComponent): PriceResult {
        return {
            price: this.calculateComponentsPriceForType(
                component as Partition,
                CostDealType,
            ),
            priceB2C: this.calculateComponentsPriceForType(
                component as Partition,
                B2CDealType,
            ),
            priceB2B: this.calculateComponentsPriceForType(
                component as Partition,
                B2BDealType,
            ),
        };
    }

    private calculateComponentsPriceForType(
        component: Partition,
        dealType: string,
    ) {
        if (!component) return 0;

        const children = component.components;
        const extraTotal = component?.getExtra()?.components.reduce((extraTotal, acc) => {
            return extraTotal + acc.sum.getSystemPrice(dealType).getValue()
        }, 0) || 0;


        const childrenSum = children.reduce((total, child) => {
            const sum = child.sum.getSystemPrice(dealType).getValue();

            return total + sum;
        }, 0);

        return extraTotal + childrenSum;
    }
}
